import { Button } from "@/pages/quiz/15000/components/Button";
import { Radio } from "@/pages/quiz/15000/components/Radio";
import { QuizQuestionProps } from "@/pages/quiz/context/types";

const icons: Record<string, any> = {
  male: "🙋‍",
  female: "🙋‍♀️",
};

type Option = {
  label: string;
  value: string;
};

const SelectSexQuestion = ({
  question,
  questionValue,
  setQuestionAnswer,
  setQuestionValue,
}: QuizQuestionProps<string>) => {
  const options = question?.attributes?.options as Option[] | undefined;

  if (!options?.length) {
    return null;
  }

  return (
    <>
      <div className="w-full flex flex-col gap-6">
        <div className="flex flex-col space-y-1">
          {options?.map(({ value, label }, index) => (
            <Radio
              key={`${value}-${index}`}
              label={
                <span className="flex items-center gap-4">
                  <span className="text-2xl flex-0">
                    {icons?.[value] || ""}
                  </span>

                  {label}
                </span>
              }
              value={value}
              checked={questionValue === value}
              onClick={() => setQuestionValue(value)}
              className="first:rounded-t-2xl last:rounded-b-2xl"
              disableIcon
            />
          ))}
        </div>
      </div>
      <Button
        onClick={() => setQuestionAnswer(questionValue)}
        disabled={!questionValue}
      />
    </>
  );
};

export { SelectSexQuestion };
